import React from 'react'
import image from '../../Assets/home/Getknowbg.png'
import icons from '../../Assets/home/righticons.png'
const GetToknow = () => {
    return (
        
        <div
            className='grid lg:grid-cols-[1.5fr_2.5fr] grid-cols-1 items-center md:p-10 md:py-20'
            style={{
                backgroundImage: `url(${image})`,
                backgroundSize: "cover",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center",
            }}>
            <div className='text-white p-8 items-center'>
                <h5 className="lato-thin-italic text-[#FF8F61] leading-normal text-base" data-aos="fade-right">Get To Know Us</h5>
                <h1 className='font-serif font-extrabold text-3xl md:text-5xl leading-normal md:leading-normal' data-aos="zoom-in">Why You Should Choose Us?</h1>
                <p className='leading-normal mt-4 capitalize text-base md:text-lg opacity-70' data-aos="flip-up">In the sanctuary of spa moments, where time dances with serenity, whispers of tranquility delicately weave a poetic tapestry on the canvas of the body.</p>
            </div>
            <div className='grid md:grid-cols-2 grid-cols-1 gap-6 p-8 md:pt-8 pt-2 '>
                <div className='bg-black flex flex-col space-y-2 p-6 md:p-8' data-aos="flip-down">
                    <div className='flex items-center space-x-5 mb-2'>
                        <img src={icons} alt='img' className='w-10' />
                        <h1 className='text-white font-bold text-xl font-serif'>Expert Staff</h1>
                    </div>
                    <p className='text-white opacity-60 font-thin capitalize tracking-wide text-sm px-1'>
                        Our skilled professionals provide personalized consultations to meet your unique beauty needs.
                    </p>
                </div>
                <div className='bg-black flex flex-col space-y-2 p-6 md:p-8' data-aos="flip-down">
                    <div className='flex items-center space-x-5 mb-2'>
                        <img src={icons} alt='img' className='w-10' />
                        <h1 className='text-white font-bold text-xl font-serif'>Quality Products</h1>
                    </div>
                    <p className='text-white opacity-60 font-thin capitalize tracking-wide text-sm px-1'>
                        We use only high-quality, cruelty-free products to ensure the best results for your skin and hair.
                    </p>
                </div>
                <div className='bg-black flex flex-col space-y-2 p-6 md:p-8' data-aos="flip-down">
                    <div className='flex items-center space-x-5 mb-2'>
                        <img src={icons} alt='img' className='w-10' />
                        <h1 className='text-white font-bold text-xl font-serif'>Relaxing Environment</h1>
                    </div>
                    <p className='text-white opacity-60 font-thin capitalize tracking-wide text-sm px-1'>
                        Enjoy a serene and calming atmosphere that enhances your overall spa experience.
                    </p>
                </div>
                <div className='bg-black flex flex-col space-y-2 p-6 md:p-8' data-aos="flip-down">
                    <div className='flex items-center space-x-5 mb-2'>
                        <img src={icons} alt='img' className='w-10' />
                        <h1 className='text-white font-bold text-xl font-serif'>Customized Packages</h1>
                    </div>
                    <p className='text-white opacity-60 font-thin capitalize tracking-wide text-sm px-1'>
                        Choose from a variety of packages tailored to suit your individual preferences and needs.
                    </p>
                </div>
            </div>

        </div>
    )
}

export default GetToknow